import { faker } from '@faker-js/faker';
import { type HttpResponseResolver, HttpResponse } from 'msw';
import { parse } from 'qs-esm';

export const mockSummaryEndpoint: HttpResponseResolver = ({ request }) => {
  const url = new URL(request.url);

  const { selectedYears } = parse(url.search, {
    ignoreQueryPrefix: true,
  });
  return HttpResponse.json({
    summary: (selectedYears as string[])?.flatMap((year) => [
      {
        id: 'budget',
        year: Number(year),
        value: faker.number.int({ min: 1_000_000_000, max: 1_000_000_000 }),
        percentGrowthLastYear: faker.number.int({ min: -100, max: 100 }),
      },
      {
        id: 'expenditure',
        year: Number(year),
        value: faker.number.int({ min: 1_000_000_000, max: 1_000_000_000 }),
        percentGrowthLastYear: faker.number.int({ min: -100, max: 100 }),
      },
      {
        id: 'funding_gap',
        year: Number(year),
        value: faker.number.int({ min: 1_000_000, max: 1_000_000_000 }),
        percentGrowthLastYear: faker.number.int({ min: -100, max: 100 }),
      },

      {
        id: 'budget_and_expenditure',
        year: Number(year),
        value: faker.number.int({ min: 1_000_000, max: 1_000_000_000 }),
        percentGrowthLastYear: faker.number.int({ min: -100, max: 100 }),
      },

      {
        id: 'contributions',
        year: Number(year),
        value: faker.number.int({ min: 1_000_000, max: 1_000_000_000 }),
        percentGrowthLastYear: faker.number.int({ min: -100, max: 100 }),
      },
    ]),
  });
};
